// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"2a718252","183":"21bbe6fe","456":"b541f36a","633":"2520a5ee","691":"21bbe6fe","762":"21bbe6fe","767":"244b5af8","906":"2a718252","937":"244b5af8"}[chunkId] + ".chunk.css";
};